// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photoPreviewContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 88%;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1); /* Adjust shadow as needed */
}
@media screen and (min-width: 1024px) {
  .photoPreviewContainer {
    width: 50%;
  }
}
.communityDetailsContainer {
  max-height: 35vh;
  overflow-y: auto;
  overflow-x: hidden;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #bdbdbd transparent;
}

/* Chrome, Edge, Safari */
.communityDetailsContainer::-webkit-scrollbar {
  width: 5px;
}

.communityDetailsContainer::-webkit-scrollbar-track {
  background: transparent;
}

.communityDetailsContainer::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 10px;
}

.communityDetailsContainer::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
.photoContainer {
  margin: 2px 10px;
}
.slider {
  border: none !important;
}
.slider.slick-slider .slick-list {
  padding: 0 !important;
  overflow: hidden;
}

.slider.slick-slider .slick-track {
  display: flex !important;
  justify-content: flex-start !important;
  margin-left: 0 !important;
}

.slider.slick-slider .slick-slide {
  float: none !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.community-image-container {
  position: "relative";
  min-height: "220px";
}
.location-close-button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 10px;
    padding-top: 10px;
    position: absolute;
    top: 10px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .back-forward-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    box-sizing: border-box;
  }

  .location-button {
    background-color: transparent;
    border: none;
    border-radius: 20px;
    padding: 5px 14px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: inline-block; /* Inline button */
    max-width: 100%;
    outline: none !important;
  }
  
  .location-button:hover {
    background-color: transparent;
  }
  
  .location-content {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  
  .location-icon {
    color: #8E8E8E;
    margin-right: 2px;
    height: 16px !important;
    width: 14px !important;
  }
  .community-location-icon-button{
    border-width: 0px;
    background-color: transparent;
    outline: none !important;
  }
  .community-location-icon{
    height: 16px !important;
    width: 14px !important;
    margin-top: -8px !important;
  }
/*   
  .location-text {
    margin-bottom: 0px;
    word-break: break-word;
    color: #373334b1;
    font-size: 16px;
  } */
  .location-text {
    margin-bottom: 0px;
    word-break: break-word;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */
    white-space: nowrap;
    color: #373334;
  }
  .community-name-location-container{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
  }
  .community-name{
    margin-bottom: 5px;
    word-break: break-word;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */
    white-space: nowrap;
    font-size: 18px;
    color: #373334;
    margin-left: 16px;
  }

  .community-description-text-and-location-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 5px;
    padding-left: 2px;
  }

  .community-description-text{
    margin-bottom: -2px;
    word-break: break-word;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */
    white-space: nowrap;
    font-size: 14px;
    color: #373334;
    margin-left: 15px !important;
  }
  .cross-icon{
    height: 19px;
  }
  
  .icon-button {
    background-color: transparent !important;
    color: black;
    outline: none !important;
  }
  
  .icon-arrow {
     font-size: medium;
     font-weight: bolder; 
     filter: invert(0);
     outline: none !important;
  }
  .selected-image {
    border: 4px solid #4795DE;
    border-radius: 8px;
  }
  
  .slider-image{
    border-radius: 10px;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/Components/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C,EAAE,4BAA4B;AAC3E;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;;EAElB,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,qBAAqB,EAAE,kBAAkB;IACzC,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;;;;;KAMK;EACH;IACE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,uBAAuB,EAAE,6CAA6C;IACtE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,uBAAuB,EAAE,6CAA6C;IACtE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,uBAAuB,EAAE,6CAA6C;IACtE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;EACA;IACE,YAAY;EACd;;EAEA;IACE,wCAAwC;IACxC,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;KACG,iBAAiB;KACjB,mBAAmB;KACnB,iBAAiB;KACjB,wBAAwB;EAC3B;EACA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".photoPreviewContainer {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 80%;\r\n  height: 88%;\r\n  background-color: #ffffff;\r\n  border-radius: 20px;\r\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1); /* Adjust shadow as needed */\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .photoPreviewContainer {\r\n    width: 50%;\r\n  }\r\n}\r\n.communityDetailsContainer {\r\n  max-height: 35vh;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n  /* Firefox */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #bdbdbd transparent;\r\n}\r\n\r\n/* Chrome, Edge, Safari */\r\n.communityDetailsContainer::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n.communityDetailsContainer::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.communityDetailsContainer::-webkit-scrollbar-thumb {\r\n  background: #bdbdbd;\r\n  border-radius: 10px;\r\n}\r\n\r\n.communityDetailsContainer::-webkit-scrollbar-thumb:hover {\r\n  background: #9e9e9e;\r\n}\r\n.photoContainer {\r\n  margin: 2px 10px;\r\n}\r\n.slider {\r\n  border: none !important;\r\n}\r\n.slider.slick-slider .slick-list {\r\n  padding: 0 !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.slider.slick-slider .slick-track {\r\n  display: flex !important;\r\n  justify-content: flex-start !important;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.slider.slick-slider .slick-slide {\r\n  float: none !important;\r\n  display: flex !important;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.community-image-container {\r\n  position: \"relative\";\r\n  min-height: \"220px\";\r\n}\r\n.location-close-button-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    padding-right: 10px;\r\n    padding-top: 10px;\r\n    position: absolute;\r\n    top: 10px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .back-forward-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0px 10px;\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .location-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    border-radius: 20px;\r\n    padding: 5px 14px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    display: inline-block; /* Inline button */\r\n    max-width: 100%;\r\n    outline: none !important;\r\n  }\r\n  \r\n  .location-button:hover {\r\n    background-color: transparent;\r\n  }\r\n  \r\n  .location-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .location-icon {\r\n    color: #8E8E8E;\r\n    margin-right: 2px;\r\n    height: 16px !important;\r\n    width: 14px !important;\r\n  }\r\n  .community-location-icon-button{\r\n    border-width: 0px;\r\n    background-color: transparent;\r\n    outline: none !important;\r\n  }\r\n  .community-location-icon{\r\n    height: 16px !important;\r\n    width: 14px !important;\r\n    margin-top: -8px !important;\r\n  }\r\n/*   \r\n  .location-text {\r\n    margin-bottom: 0px;\r\n    word-break: break-word;\r\n    color: #373334b1;\r\n    font-size: 16px;\r\n  } */\r\n  .location-text {\r\n    margin-bottom: 0px;\r\n    word-break: break-word;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */\r\n    white-space: nowrap;\r\n    color: #373334;\r\n  }\r\n  .community-name-location-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    gap: 5px;\r\n  }\r\n  .community-name{\r\n    margin-bottom: 5px;\r\n    word-break: break-word;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */\r\n    white-space: nowrap;\r\n    font-size: 18px;\r\n    color: #373334;\r\n    margin-left: 16px;\r\n  }\r\n\r\n  .community-description-text-and-location-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    gap: 5px;\r\n    padding-left: 2px;\r\n  }\r\n\r\n  .community-description-text{\r\n    margin-bottom: -2px;\r\n    word-break: break-word;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis; /* Added ellipsis (...) if text is too long */\r\n    white-space: nowrap;\r\n    font-size: 14px;\r\n    color: #373334;\r\n    margin-left: 15px !important;\r\n  }\r\n  .cross-icon{\r\n    height: 19px;\r\n  }\r\n  \r\n  .icon-button {\r\n    background-color: transparent !important;\r\n    color: black;\r\n    outline: none !important;\r\n  }\r\n  \r\n  .icon-arrow {\r\n     font-size: medium;\r\n     font-weight: bolder; \r\n     filter: invert(0);\r\n     outline: none !important;\r\n  }\r\n  .selected-image {\r\n    border: 4px solid #4795DE;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .slider-image{\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
